import { useState, useEffect } from 'react';
import { List, Datagrid, useRecordContext, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput } from 'react-admin';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

export const ProductFamilyText = (props) => {
    var record = useRecordContext();
    const dataProvider = useDataProvider();
    const [family, setFamily] = useState("Pas de famille");

    useEffect(() => {

        if(record != undefined){
            const productId = record.productId;
            dataProvider.getOne('products', {id: productId})
            .then(dataProduct => {
                const productFamilyId = dataProduct.data.productFamilyId;
                dataProvider.getOne('productFamilies', {id: productFamilyId})
                .then(dataFamily => {
                    setFamily(dataFamily.data.name);
                })
            })
            
        }
            
    }, [record]);

    return <span>{family}</span>;
}